
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalPluggedNoCharge50 as ObiBatteryVerticalPluggedNoCharge50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-plugged-no-charge-50.js';
 
 
 

 
 export const ObiBatteryVerticalPluggedNoCharge50 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-plugged-no-charge-50',
   elementClass: ObiBatteryVerticalPluggedNoCharge50Element,
   events: {
     
   }
  });
 
 